export default function CTypeConversion() {
  return <h2>C Type Conversion</h2>;
}
